import { ENTITY_NAMES } from "@miplatform/constants";

export const CREATE_ORDER_DRAWER_PAGES = {
  HOME_SEARCH: "Search",
  CREATE_HOME: `Create New ${ENTITY_NAMES.HOME}`,
  ORDER_TEMPLATE_SELECTION: `${ENTITY_NAMES.ORDER_TEMPLATE} Selection`,
  CREATE_ASSIGNMENT: "Create Assignment",
};

export const CREATE_ORDER_DRAWER_TITLE = {
  [CREATE_ORDER_DRAWER_PAGES.HOME_SEARCH]: `Create New ${ENTITY_NAMES.ORDER}`,
  [CREATE_ORDER_DRAWER_PAGES.CREATE_HOME]: `Create New ${ENTITY_NAMES.HOME}`,
  [CREATE_ORDER_DRAWER_PAGES.ORDER_TEMPLATE_SELECTION]: `Create New ${ENTITY_NAMES.ORDER}`,
  [CREATE_ORDER_DRAWER_PAGES.CREATE_ASSIGNMENT]: "Create Assignment",
};

export const CREATE_ORDER_DRAWER_WIDTH = 720;

export const MINIMIZE_CREATE_ORDER_DRAWER_CONFIG = {
  [CREATE_ORDER_DRAWER_PAGES.CREATE_HOME]: {
    title: "Minimize Create Home",
    description:
      "You are minimizing creating a home. This will keep your progress. Continue?",
  },
  [CREATE_ORDER_DRAWER_PAGES.CREATE_ASSIGNMENT]: {
    title: "Minimize Create Order",
    description:
      "You are minimizing creating an order. This will keep your progress. Continue?",
  },
  default: {
    title: "Minimize Drawer",
    description: "You are minimizing the drawer. Continue?",
  },
};
